import type { FoxKifuAiUserAccess, ManagedOrganizationMember } from '@wx-weiqi/contracts';

export interface AiAccessActionPresentation {
  readonly disabled: boolean;
  readonly label: '授予 AI 权限' | '取消 AI 权限' | '需先恢复登录';
}

export function presentAiAccessAction(access: FoxKifuAiUserAccess): AiAccessActionPresentation {
  if (access.authorized) {
    return Object.freeze({ disabled: false, label: '取消 AI 权限' });
  }
  if (access.membershipStatus !== 'ACTIVE' || access.userStatus !== 'ACTIVE') {
    return Object.freeze({ disabled: true, label: '需先恢复登录' });
  }
  return Object.freeze({ disabled: false, label: '授予 AI 权限' });
}

export function memberLoginActionLabel(
  status: ManagedOrganizationMember['status'],
): '停用登录' | '恢复登录' {
  return status === 'ACTIVE' ? '停用登录' : '恢复登录';
}
